import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Highcharts from '../../../../highchartsInit'
import { Chart as HighchartsReact } from '@highcharts/react'

import { isNumber } from 'altrac-conversions'
import Eventblock from './Eventblock'

import styles from '../../../../../css/timeblock.module.css'

const MINUTES_MAXIMUM = 7 * 24 * 60

export default function DateBlock (props) {
  const {
    label,
    handleUpdateEvent,
    newEvent,
    day,
    timeblocks,
    dayBegin,
    dayEnd,
    repeatDayBegin,
    repeatDayEnd,
    outletID,
    isSelect = false,
    selected,
  } = props

  const [open, setOpen] = useState(false)
  const [select, setSelect] = useState(false)

  useEffect(() => {
    if (select !== isSelect) {
      setSelect(isSelect)
      setOpen(isSelect)
    }
  })

  const chartData = [{
    x: moment(dayBegin).valueOf(),
    x2: moment(dayEnd).valueOf(),
    y: 0,
    color: 'rgba(0,0,0,0.0)',
    borderColor: 'rgba(40,64,71,0)',
    borderWidth: 0,
    pointWidth: 32,
    borderRadius: 3,
    enableMouseTracking: false,
    name: 'fulltime',
    xAxis: 0,
    yAxis: 0,
  }]

  const buttonData = []
  const fertData = []

  Object.keys(timeblocks).forEach((e) => {
    const timeblockSort = [...timeblocks[e]]
    timeblockSort.sort((a, b) => {
      const offset = new Date().getTimezoneOffset()
      let startRing = a.start
      let startRingB = b.start
      if (
        Math.abs(startRing - startRingB) < (24 * 60 + 1) &&
        (startRing < offset || startRingB < offset)
      ) {
        startRing += MINUTES_MAXIMUM
        startRingB += MINUTES_MAXIMUM
      } else if (startRing < offset) {
        startRing += MINUTES_MAXIMUM
      } else if (startRingB < offset) {
        startRingB += MINUTES_MAXIMUM
      }
      if (startRing < startRingB) {
        return -1
      }
      if (startRing > startRingB) {
        return 1
      }
      // a must be equal to b
      return 0
    })

    const colors = (selectedColor, fertColor) => {
      if (selectedColor && isSelect) return '#23ce6b'
      if (fertColor) return 'rgba(160,204,255,1)'
      return 'rgba(40,64,71,1)'
    }
    timeblockSort.forEach((f, fi) => {
      if (f && f.noLater && f.noLater < (new Date().getTime() / 1000)) {
        return
      }

      const fert = outletID === 'fertigation' && f.flags && f.flags.find((fr) => fr === 'fertigation')
      const fertMaster = f.flags && f.flags.find((fr) => fr === 'fertigation_master')
      const weekB = moment.utc().startOf('week')
      const offset = new Date().getTimezoneOffset()
      let startRing = f.start
      let stopRing = f.stop
      if (stopRing < startRing) {
        stopRing = f.stop + MINUTES_MAXIMUM
      }
      if ((startRing < offset || stopRing < offset)) {
        startRing += MINUTES_MAXIMUM
        stopRing += MINUTES_MAXIMUM
      }
      if (
        startRing > repeatDayEnd &&
        (startRing >= MINUTES_MAXIMUM || stopRing >= MINUTES_MAXIMUM) &&
        repeatDayEnd > repeatDayBegin
      ) {
        startRing -= MINUTES_MAXIMUM
        stopRing -= MINUTES_MAXIMUM
      }
      let startUTC = moment(weekB).add(startRing, 'minutes').toISOString()
      let stopUTC = moment(weekB).add(stopRing, 'minutes').toISOString()
      chartData.push({
        x: moment(startUTC).valueOf(),
        x2: moment(stopUTC).valueOf(),
        y: 0,
        // partialFill: 0.25,
        pointWidth: fert ? 8 : 32,
        color: colors(f.selected, fert),
        borderRadius: 0,
        yAxis: 0,
      })
      if (
        fertMaster &&
        Array.isArray(f.fertigationDifference) &&
        f.fertigationDifference.length >= 2 &&
        isNumber(f.fertigationDifference[0]) &&
        isNumber(f.fertigationDifference[1])
      ) {
        chartData.push({
          x: moment(startUTC).add(f.fertigationDifference[0], 'minutes').valueOf(),
          x2: moment(stopUTC).subtract(f.fertigationDifference[1], 'minutes').valueOf(),
          y: 0,
          // partialFill: 0.25,
          pointWidth: fertMaster ? 8 : 32,
          color: colors(f.selected, fertMaster),
          borderRadius: 0,
          yAxis: 0,
        })
      }
      if (!fert) {
        buttonData.push((<Eventblock key={`timeblock${e}${fi}`} event={f} handleUpdateEvent={handleUpdateEvent} outletID={e} number={timeblocks[e].length} fertigation={fertMaster} isSelect={isSelect} selected={selected} />))
      } else {
        fertData.push(f)
      }

      // if a schedule wraps around a whole week, then we need to add it a second time to the chart
      if (
        startRing > repeatDayBegin &&
        (startRing >= MINUTES_MAXIMUM || stopRing >= MINUTES_MAXIMUM)
      ) {
        startRing -= MINUTES_MAXIMUM
        stopRing -= MINUTES_MAXIMUM
        startUTC = moment(weekB).add(startRing, 'minutes').toISOString()
        stopUTC = moment(weekB).add(stopRing, 'minutes').toISOString()
        chartData.push({
          x: moment(startUTC).valueOf(),
          x2: moment(stopUTC).valueOf(),
          y: 0,
          // partialFill: 0.25,
          pointWidth: fert ? 8 : 32,
          color: colors(f.selected, fert),
          borderRadius: 0,
          yAxis: 0,
        })
        if (
          fertMaster &&
          Array.isArray(f.fertigationDifference) &&
          f.fertigationDifference.length >= 2 &&
          isNumber(f.fertigationDifference[0]) &&
          isNumber(f.fertigationDifference[1])
        ) {
          chartData.push({
            x: moment(startUTC).add(f.fertigationDifference[0], 'minutes').valueOf(),
            x2: moment(stopUTC).subtract(f.fertigationDifference[1], 'minutes').valueOf(),
            y: 0,
            // partialFill: 0.25,
            pointWidth: fertMaster ? 8 : 32,
            color: colors(f.selected, fertMaster),
            borderRadius: 0,
            yAxis: 0,
          })
        }
      }
    })
  })

  const series = [{
    pointRange: 1,
    borderColor: 'none',
    borderRadius: 0,
    partialFill: {
      fill: 'rgba(191,197,199,1)',
    },
    pointWidth: 20,
    data: chartData,
    dataLabels: {
      enabled: false,
    },
    yAxis: 0,
  }]

  const today = new Date().getDay() === day
  if (today) {
    series.push({
      type: 'scatter',
      marker: {
        enabled: true,
        symbol: 'triangle-down',
        radius: 8,
      },
      data: [{
        x: moment().valueOf(),
        y: 10,
      }],
      yAxis: 1,
      enableMouseTracking: false,
    })
  }

  const options = {
    accessibility: {
      enabled: false,
    },
    chart: {
      type: 'xrange',
      borderWidth: 0,
      height: '74px',
      animation: false,
    },
    time: {
      useUTC: false,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
    plotOptions: {
      xrange: {
        dataLabels: {
          enabled: true,
        },
        minPointLength: 1,
        enableMouseTracking: true,
        animation: false,
      },
      scatter: {
        dataLabels: {
          enabled: false,
        },
        color: 'none',
        marker: {
          enabled: true,
          fillColor: '#23ce6b',
          lineColor: 'white',
          lineWidth: 1,
        },
        states: {
          hover: { enabled: false },
          inactive: { enabled: false },
        },
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      backgroundColor: 'white',
      borderColor: '#284047',
      borderRadius: 3,
      borderWidth: 1,
      shadow: false,
      distance: 12,
      outside: true,
      formatter () {
        if (this.key === 'fulltime') return false
        return `<div style="overflow:visible;">${moment(this.x).format('ddd h:mmA')} to ${moment(this.x2).format('ddd h:mmA')}</div>`
      },
      useHTML: true,
      shape: 'square',
    },
    xAxis: [
      {
        type: 'datetime',
        labels: {
          formatter () {
            let hour = Number(moment(this.value).format('H'))
            if (hour > 12) hour -= 12
            if (hour === 12) return '12PM'
            if (hour === 0) return ''
            return hour
          },
          // Highcharts 12 expects a style object; ensure it always exists
          style: { whiteSpace: 'nowrap' },
        },
        min: moment(dayBegin).valueOf(),
        max: moment(dayEnd).valueOf(),
        tickInterval: 3 * 3600 * 1000,
        endOnTick: false,
      },
    ],
    yAxis: [{
      title: {
        text: '',
      },
      categories: ['Times'],
      reversed: true,
      labels: {
        enabled: false,
        // Explicitly provide a style object to avoid undefined accesses
        style: { whiteSpace: 'nowrap' },
      },
      tickAmount: 1,
      gridLineWidth: 0,
    }, {
      title: {
        text: '',
      },
      categories: ['Times'],
      reversed: true,
      labels: {
        enabled: false,
        style: { whiteSpace: 'nowrap' },
      },
      min: 0,
      max: 10,
      gridLineWidth: 0,
    }],
    series,
  }

  return (
    <div className={`${styles.date}`}>
      <div onClick={() => !isSelect && setOpen(!open)}>
        <div className={styles.date_text}>
          <span><strong>{label}</strong></span>
          <span>
            <button onClick={() => !isSelect && newEvent(day)} type='button' name={`add-item-day-${day}`}>
              {!isSelect ? '+' : ''}
            </button>
          </span>
        </div>
        <div style={{ height: '74px', width: '100%' }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
          />
        </div>
      </div>
      {open &&
        (
          <div style={{ padding: '20px' }} onClick={() => !isSelect && newEvent(day)} role='dateblock'>
            {buttonData}
          </div>
        )}
    </div>
  )
}
DateBlock.propTypes = {
  dayBegin: PropTypes.string,
  dayEnd: PropTypes.string,
  label: PropTypes.string,
  outletID: PropTypes.string,
  day: PropTypes.number,
  timeblocks: PropTypes.object,
  repeatDayBegin: PropTypes.number,
  repeatDayEnd: PropTypes.number,
  isSelect: PropTypes.bool,
  selected: PropTypes.func.isRequired,
  handleUpdateEvent: PropTypes.func.isRequired,
  newEvent: PropTypes.func.isRequired,
}
